// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeWorkData  {
    _originalTypeClassName = "Loom.BO.EmployeeWorkData";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeWorkData.translate = translateService;
}
this.Id = null;
this.Month = null;
this.DateFrom = null;
this.DateTo = null;
this.WorkableHours = null;
this.WorkableDays = null;
this.WorkableMonths = null;
this.RateHourly = null;
this.RateDaily = null;
this.RateMonthly = null;
this.RateAnnual = null;
this.MaxWeeklyHours = null;
this.MaxDailyHours = null;
this.MaxMonthlyHours = null;
this.MaxAnnualHours = null;
this.AnnualCosts = null;
this.DayEquivalentHours = null;
this.AbsenceDays = null;
this.MeetingHours = null;
this.CountryWorkableDays = null;
this.NumberOfMonthsInPeriod = null;
this.PeriodCosts = null;
this.OrganisationId = null;
this.ContractId = null;
this.ECEmployeeCategory = null;
this.ProjectsWorkedOn = null;
this.HoursInTimesheets = null;
this.FTE = null;
this.IsSummary = false;
this.MaxDayEquivalentsInPeriod = null;
this.MaxDayEquivalentsMonthsInPeriod = null;
this.TripDays = null;
this.BasedInCountry = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Month:any;
DateFrom:any;
DateTo:any;
WorkableHours:any;
WorkableDays:any;
WorkableMonths:any;
RateHourly:any;
RateDaily:any;
RateMonthly:any;
RateAnnual:any;
MaxWeeklyHours:any;
MaxDailyHours:any;
MaxMonthlyHours:any;
MaxAnnualHours:any;
AnnualCosts:any;
DayEquivalentHours:any;
AbsenceDays:any;
MeetingHours:any;
CountryWorkableDays:any;
NumberOfMonthsInPeriod:any;
PeriodCosts:any;
OrganisationId:any;
ContractId:any;
ECEmployeeCategory:any;
ProjectsWorkedOn:any;
HoursInTimesheets:any;
FTE:any;
IsSummary:any;
MaxDayEquivalentsInPeriod:any;
MaxDayEquivalentsMonthsInPeriod:any;
TripDays:any;
BasedInCountry:any;
Contract:any;
static setContract = ($this, value) => {
var oldValue = $this.Contract;
$this.Contract = value;
if (value != null) {
}
}

static CreateSummary(items: any): any{if ((items == null || CLMS.Framework.Number.Equal(() => items.length, () => 0))) {return null;}
let summary = new Domain.EmployeeWorkData();
Domain.EmployeeWorkData.setContract(summary, items[0]?.Contract);
summary.Month = items[0]?.Month;
summary.DateFrom = items?.linq?.select((x) => x?.DateFrom)?.min();
summary.DateTo = items?.linq?.select((x) => x?.DateTo)?.max();
summary.WorkableHours = items?.linq?.sum((x) => x?.WorkableHours);
summary.WorkableDays = items?.linq?.sum((x) => x?.WorkableDays);
summary.WorkableMonths = items?.linq?.sum((x) => x?.WorkableMonths);
summary.AnnualCosts = items?.linq?.select((x) => x?.AnnualCosts)?.average();
summary.AbsenceDays = items?.linq?.sum((x) => x?.AbsenceDays);
summary.MeetingHours = items?.linq?.sum((x) => x?.MeetingHours);
summary.CountryWorkableDays = items?.linq?.sum((x) => x?.CountryWorkableDays);
summary.NumberOfMonthsInPeriod = items?.linq?.sum((x) => x?.NumberOfMonthsInPeriod);
summary.PeriodCosts = items?.linq?.sum((x) => x?.PeriodCosts);
summary.HoursInTimesheets = items?.linq?.sum((x) => x?.HoursInTimesheets);
summary.DayEquivalentHours = items?.linq?.select((x) => x?.DayEquivalentHours)?.average();
summary.RateHourly = items?.linq?.select((x) => x?.RateHourly)?.average();
summary.RateDaily = items?.linq?.select((x) => x?.RateDaily)?.average();
summary.RateMonthly = items?.linq?.select((x) => x?.RateMonthly)?.average();
summary.RateAnnual = items?.linq?.select((x) => x?.RateAnnual)?.average();
summary.MaxWeeklyHours = items?.linq?.select((x) => x?.MaxWeeklyHours)?.max();
summary.MaxDailyHours = items?.linq?.select((x) => x?.MaxDailyHours)?.max();
summary.MaxMonthlyHours = items?.linq?.select((x) => x?.MaxMonthlyHours)?.max();
summary.MaxAnnualHours = items?.linq?.select((x) => x?.MaxAnnualHours)?.max();
let totalDays = items?.linq?.sum((x) => x?.WorkableDays);
if ((CLMS.Framework.Number.GreaterThan(() => totalDays, () => 0))) {summary.FTE = Joove.Common.safeNumber(items?.linq?.sum((x) => Joove.Common.safeNumber(x?.FTE) * Joove.Common.safeNumber(x?.WorkableDays))) / Joove.Common.safeNumber(totalDays);}else {summary.FTE = 0;}
summary.ECEmployeeCategory = CLMS.Framework.String.Join(", ", items?.linq?.select((x) => x?.ECEmployeeCategory)?.toArray()?.linq?.distinct()?.toArray());
let projects = [];
let itemsWithProjects = items?.linq?.where((b) => !(CLMS.Framework.String.IsNullOrEmpty((b?.ProjectsWorkedOn ?? '').trim())))?.toArray();
for (let _iwd = 0; _iwd < (itemsWithProjects == null ? 0 : itemsWithProjects.length); _iwd++) {let wd = itemsWithProjects[_iwd];let prjs = System.split(wd?.ProjectsWorkedOn, [","], true);projects?.addRange(prjs);}
summary.ProjectsWorkedOn = CLMS.Framework.String.Join(", ", projects?.linq?.distinct()?.toArray());
summary.OrganisationId = items[0]?.OrganisationId;
summary.ContractId = items[0]?.ContractId;
summary.IsSummary = true;
return summary;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}